<template>
	<div :class="['service', { mobile: isMobile }]">	
		<section ref="sec1" :class="['sec-1',{active: n > 0}]">
			<!-- <video 
				v-if="!isMobile" 
				ref="video" 
				muted 
				preload  
				autoplay
				playsinline
				x5-video-player-type="h5-page"
				@ended="n = 1"
				src="../assets/image/service/banner.mp4"></video> -->
			<div :class="['imgs', {active: n> 0}]">
				<img
					class="cloud"
					:src="isMobile? require('../assets/image/space/mobile/cloud-1.png'):require('../assets/image/space/cloud-1.png')"
					alt=""
				/>
				<img
					class="cloud"
					:src="isMobile? require('../assets/image/space/mobile/cloud-2.png'):require('../assets/image/space/cloud-2.png')"
					alt=""
				/>
				<img
          v-if="!isMobile"
					class="cloud"
					src="../assets/image/space/cloud-3.png"
					alt=""
				/>
				<img
          v-if="!isMobile"
					class="cloud"
					src="../assets/image/space/cloud-4.png"
					alt=""
				/>
				<img
          v-if="!isMobile"
					class="cloud"
					src="../assets/image/space/cloud-5.png"
					alt=""
				/>
				<div class="line" v-if="!isMobile"></div>
				<div class="line" v-if="!isMobile"></div>
				<div class="line" v-if="!isMobile"></div>
				<div class="line" v-if="!isMobile"><span>231</span></div>
				<div class="line" v-if="!isMobile"><span>132</span></div>
				<div class="line" v-if="!isMobile"><span>1680</span></div>
				<div class="line" v-if="!isMobile"></div>
				<div class="line" v-if="!isMobile"><span>42</span></div>
				<div class="line" v-if="!isMobile"><span>432</span></div>
				<div class="line" v-if="!isMobile"></div>
				<div class="line" v-if="isMobile"></div>
				<div class="line" v-if="isMobile"><span>231</span></div>
				<div class="line" v-if="isMobile"></div>
				<div class="line" v-if="isMobile"></div>
				<div class="line" v-if="isMobile"><span>1680</span></div>
				<div class="line" v-if="isMobile"></div>
			</div>
      <div class="caption">
				<h3 :class="['title textfade', {textfade1: n > 0}]" v-html="text.first.title"></h3>
				<p :class="['text textfade', {textfade2: n > 0}]" v-html="text.first.text"></p>
			</div>
			<!-- <div class="more" @click="handleSlideNext">{{text.first.tips}}</div> -->
      <show-more @handleSecond="handleSecond"></show-more>
		</section>
		<section class="sec-2">
			<div class="caption">
				<h3 :class="['title textfade', {textfade1: n > 1}]" v-html="text.second.title"></h3>
				<p :class="['text textfade', {textfade2: n > 1}]" v-html="text.second.text"></p>
				<ul class="tips">
					<li :class="['textfade', {textfade3: n > 1}]">{{ text.second.tips[0] }}</li>
					<li :class="['textfade', {textfade4: n > 1}]">{{ text.second.tips[1] }}</li>
					<li :class="['textfade', {textfade5: n > 1}]">{{ text.second.tips[2] }}</li>
				</ul>
			</div>
			<div :class="['images', { active: n > 1}]">
				<template v-if="isMobile">
					<div
						class="airport"
						v-for="(item, index) in Array(5)"
						:key="index"
					>
						<img
							class="uav"
							:src="
								require(`@/assets/image/service/mobile/web-p2-f${index +
									1}.svg`)
							"
							alt=""
							srcset=""
						/>
						<div class="l"></div>
						<img
							class="base"
							:src="
								require(`@/assets/image/service/mobile/web-p2-t${index +
									1}.svg`)
							"
							alt=""
							srcset=""
						/>
					</div>
				</template>
				<template v-else>
					<div
						class="airport"
						v-for="(item, index) in Array(9)"
						:key="index"
					>
						<img
							class="uav"
							:src="
								require(`@/assets/image/service/P2-B${index +
									1}.svg`)
							"
							alt=""
							srcset=""
						/>
						<div class="l"></div>
						<img
							class="base"
							:src="
								require(`@/assets/image/service/P2-A${index +
									1}.svg`)
							"
							alt=""
							srcset=""
						/>
					</div>
				</template>
				<template v-if="isMobile">
					<img
						v-for="(item, index) in Array(4)"
						:key="index + 15"
						:src="
							require(`@/assets/image/service/mobile/web-p2-c${index + 1}.svg`)
						"
						alt=""
						class="line"
					/>
				</template>
				<template v-else>
						<img
						v-for="(item, index) in Array(8)"
						:key="index + 30"
						:src="
							require(`@/assets/image/service/P2-C${index + 1}.svg`)
						"
						alt=""
						class="line"
					/>
				</template>
			</div>
		</section>
		<section class="sec-3">
			<div class="caption">
				<h3 :class="['title textfade', {textfade1: n > 2}]" v-html="text.third.title"></h3>
				<p :class="['text textfade', {textfade2: n > 2}]" v-html="text.third.text"></p>
			</div>
            <div v-if="!isMobile" :class="['line-group', {active: n > 2}]">
                <div class="line-1"></div>
                <div class="line-2"></div>
                <div class="line-3"></div>
                <div class="line-4"></div>
                <div class="line-5"></div>
                <div class="line-6"></div>
                <div class="line-7"></div>
                <div class="line-8"></div>
                <div class="line-9"></div>
                <div class="line-10"></div>
                <div class="line-11"></div>
                <div class="line-12"></div>
                <div class="line-13"></div>
            </div>
			<div :class="['cloud-wrap', { active: n>2 }]">
				<div class="cloud-animate" ref="container"></div>
				<div class="cloud-container">
					<img class="cloud" src="../assets/image/service/P3-YUN.svg" alt="" srcset="">
					<span class="cloud-text">{{ text.third.tips }}</span>
				</div>
			</div>

		</section>
		<section class="sec-4">
			<div class="caption">
				<h3 :class="['title textfade',{textfade1:n>3}]" v-html="text.forth.title"></h3>
			</div>
			<div :class="{'swiper-container': isMobile}">
				<ul :class="['group', {'swiper-wrapper': isMobile}]">
					<li
						v-for="(item, index) in text.forth.text"
						:key="index"
						:class="[index % 2 ? 'right-text' : 'left-text', {'swiper-slide': isMobile}]"
					>
						<div class="image">
							<img
								v-if="isMobile"
								class="bg"
								:src="require(`@/assets/image/service/mobile/web-P4-${index}.png`)"
								alt=""
								srcset=""
							/>
							<img
								v-else
								:src="require(`@/assets/image/service/P4-${index}.jpg`)"
								alt=""
								srcset=""
							/>
							<div :class="['figure-group safe', {active: n > 3 && !isMobile}]" v-if="index === 0">
								<img
									class="line"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-0-1.svg`)"
									alt=""
								/>
								<img
									class="inner"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-0-2.svg`)"
									alt=""
								/>
								<img
									class="circle-o"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-0-3.svg`)"
									alt=""
								/>
								<img
									class="warn"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-0-4.svg`)"
									alt=""
								/>
								<img
									class="circle-w"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-0-5.svg`)"
									alt=""
								/>
								<img
									v-if="!isMobile && n>1"
									class="text"
									src="@/assets/image/service/P4-0-6.svg"
									alt=""
								/>
							</div>
							<div :class="['figure-group build',{active: n>4 && !isMobile}]" v-if="index === 1">
								<img
									class="line-b"
									src="@/assets/image/service/P4-1-1.svg"
									alt=""
								/>
								<img
									class="rect-l"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-1-2.svg`)"
									alt=""
								/>
								<img
									class="rect-s"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-1-3.svg`)"
									alt=""
								/>
								<img
									class="rect-m"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-1-4.svg`)"
									alt=""
								/>
							</div>
							<div :class="['figure-group emergency', {active: n>5 && !isMobile}]" v-if="index === 2">
								<img
									class="left"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-2-1.png`)"
									alt=""
								/>
								<img
									class="right"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-2-2.png`)"
									alt=""
								/>
							</div>
							<div
								:class="['figure-group transportation', {active: n>6 && !isMobile}]"
								v-if="index === 3"
							>
								<img
									class="car"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-3-1.png`)"
									alt=""
								/>
								<img
									class="circle"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-3-2.svg`)"
									alt=""
								/>
								<img
									class="line"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-3-3.svg`)"
									alt=""
								/>
								<img
									class="info"
									:src="require(`@/assets/image/service/${isMobile ? 'mobile/web-':''}P4-3-4.png`)"
									alt=""
								/>
							</div>
						</div>
						<div class="img-caption">
							<h4 :class="['img-title',{textfade1: n>index+3 && !isMobile, textfade:  !isMobile}]">{{ item.title }}</h4>
							<p :class="['image-text', {textfade2: n>index+3 && !isMobile, textfade:  !isMobile}]" >{{ item.text }}</p>
							<ul class="image-tips">
								<template  v-for="(t, i) in item.tips">
										<li :class="[{textfade: !isMobile},n > index + 3 && !isMobile? `textfade${i+3}` : '']" :key="i">
												{{ t }}
										</li>
								</template>
							</ul>
						</div>
					</li>
				</ul>
				<div v-if="isMobile" class="swiper-pagination"></div>
			</div>
		</section>
		<section class="sec-5">
			<div class="caption">
				<h3 :class="['title textfade', {textfade1: n>7}]" v-html="text.fifth.title"></h3>
				<p :class="['text textfade',{textfade2: n>7}]" v-html="text.fifth.text"></p>
			</div>
			<div :class="['process',{active: n>7}]">
				<div class="outer">{{ text.fifth.tips[0] }}</div>
				<div class="arrow">{{ text.fifth.tips[1] }}</div>
				<div class="inner">
					<h4 class="process-title">{{ text.fifth.tips[2] }}</h4>
					<div>
						<span>{{ text.fifth.tips[3] }}</span>
					</div>
					<div>
						<span>{{ text.fifth.tips[4] }}</span>
					</div>
					<div>
						<span>{{ text.fifth.tips[5] }}</span>
					</div>
				</div>
				<div class="arrow">{{ text.fifth.tips[6] }}</div>
				<div class="outer">{{ text.fifth.tips[7] }}</div>
			</div>
		</section>
		<foot></foot>
		<script type="x-shader/x-vertex" id="vertexshader">

			attribute float scale;

			void main() {

				vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

				gl_PointSize = scale * ( 50.0 / - mvPosition.z );

				gl_Position = projectionMatrix * mvPosition;

			}
		</script>
		<script type="x-shader/x-fragment" id="fragmentshader">

			uniform vec3 color;

			void main() {

				if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;
				gl_FragColor = vec4( color, 1.0 );				

			}
		</script>
	</div>
</template>

<script>
import { isMobile } from '@/js/utils'
import { service } from '@/js/text'
import { mapState, mapMutations } from 'vuex'
import * as THREE from 'three'
import 'swiper/css/swiper.min.css'
import Swiper from 'swiper'

export default {
	name: 'service',
	metaInfo: {
		meta: [
			{
				name: 'keywords',
				content:
					'无人机,集成式操控台,侦查,观测者,调查取证,秒级成图,三维重建,公安巡查,应急搜救,户外探险,军事侦查,图像识别,目标跟踪,自动机场,石油管道,深度学习,定点巡航,守望者,航道巡检巡逻,高速巡逻,管道巡检,电网巡检'
			},
			{
				name: 'description',
				content:
					'埃洛克防务系统(南京)有限公司成立于2019年，核心成员来自国家大型军用无人机“彩虹”团队与知名互联网公司，联合航天科技集团及各大高校打造多款空间高精度数据采集系统。目前旗下共发布了3个系列产品：观测者、守望者、采集者。已广泛应用于国家各部委、企事业单位及民用市场。'
			}
		]
	},
	data() {
		return {
            isMobile: true,
            n: 0,
						width: window.innerWidth,
						swiper: null
		}
	},
	components: {
		Foot: () => import('../components/footer'),
    ShowMore: () => import("../components/common/ShowMore")
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? service.CN : service.EN
		}
	},
	watch: {
		$route() {
			if(this.isMobile) {
				this.swiper.destroy(true)
				this.$nextTick(() => {
					this.initSwiper()
				})
			}
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle']),
		initThree() {
			const SEPARATION = this.isMobile ? 60 : 100,
				AMOUNTX = 260,
				AMOUNTY = this.isMobile ? 600 : 150
			let wrap = this.$refs.container
			let container
			let camera, scene, renderer
			let particles,
				count = 0
			let that = this
			init()
			animate()			
			function init() {
				container = document.createElement('div')
				wrap.appendChild(container)
				camera = new THREE.PerspectiveCamera(
					100,
					wrap.offsetWidth / wrap.offsetHeight,
					1,
					10000
				)
				camera.position.z = 200
				scene = new THREE.Scene()
				const numParticles = AMOUNTX * AMOUNTY
				const positions = new Float32Array(numParticles * 3)
				const scales = new Float32Array(numParticles)
				let i = 0,
					j = 0
				for (let ix = 0; ix < AMOUNTX; ix++) {
					for (let iy = 0; iy < AMOUNTY; iy++) {
						positions[i] =
							ix * SEPARATION - (AMOUNTX * SEPARATION) / 3 // x
						positions[i + 1] = 0 // y
						positions[i + 2] =
							iy * SEPARATION - (AMOUNTY * SEPARATION) / 3 // z

						scales[j] = 1
						i += 3
						j++
					}
				}
				const geometry = new THREE.BufferGeometry()
				geometry.setAttribute(
					'position',
					new THREE.BufferAttribute(positions, 3)
				)
				geometry.setAttribute(
					'scale',
					new THREE.BufferAttribute(scales, 1)
				)
				const material = new THREE.ShaderMaterial({
					uniforms: {
						color: { value: that.isMobile ? new THREE.Color(0x274996): new THREE.Color(0xffffff) },
					},
					vertexShader: document.getElementById('vertexshader')
						.textContent,
					fragmentShader: document.getElementById('fragmentshader')
						.textContent
				})
				particles = new THREE.Points(geometry, material)
				scene.add(particles)
				renderer = new THREE.WebGLRenderer({
					antialias: true,
					alpha: true
				})
				renderer.setPixelRatio(window.devicePixelRatio)
				renderer.setSize(wrap.offsetWidth, wrap.offsetHeight)
				container.appendChild(renderer.domElement)
				container.style.touchAction = 'none'
				window.addEventListener('resize', onWindowResize)
			}
			function onWindowResize() {
				camera.aspect = wrap.offsetWidth / wrap.offsetHeight
				camera.updateProjectionMatrix()
				renderer.setSize(wrap.offsetWidth, wrap.offsetHeight)
			}
			function animate() {
				requestAnimationFrame(animate)
				render()
			}
			function render() {
				camera.position.x += -camera.position.x * 0.05
				camera.position.y += (wrap.offsetHeight * 1.7  - camera.position.y) * 0.05
				camera.lookAt(scene.position)
				const positions = particles.geometry.attributes.position.array
				const scales = particles.geometry.attributes.scale.array
				let i = 0,
					j = 0
				for (let ix = 0; ix < AMOUNTX; ix++) {
					for (let iy = 0; iy < AMOUNTY; iy++) {
						positions[i + 1] =
							Math.sin((iy + count) * 0.3) * 30 +
							Math.sin((ix + count) * 0.3) * 30
						scales[j] =
							(Math.sin((ix + count) * 0.3) + 3) *  (that.isMobile ? 50 : 15)
						i += 3
						j ++
					}
				}

				particles.geometry.attributes.position.needsUpdate = true
				particles.geometry.attributes.scale.needsUpdate = true
				renderer.render(scene, camera)
				count += that.isMobile ? 0.08 : 0.06
			}
		},
		// handleSlideNext() {
		// 	document.body.scrollTop = document.documentElement.scrollTop = window.innerWidth 
		// },
    handleSecond() {
			let h = this.$refs.sec1.offsetHeight
			let scrollTo = () => {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop < h && h - scrollTop > 15) {
					document.documentElement.scrollTop = scrollTop + (h - scrollTop) * 0.15
					document.body.scrollTop = scrollTop + (h - scrollTop) * 0.15
					window.requestAnimationFrame(scrollTo)
				}else {
					document.documentElement.scrollTop = h
					document.body.scrollTop = h 
				}
			}
			scrollTo()
		},
		initSwiper() {
			this.swiper = new Swiper('.swiper-container', {
				loop: true,
				observer: true,
				observeParents: true,
				pagination: {
					el: '.swiper-pagination'
				}
			})
		},
		scroll() {
				let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
				let blockHeight = 540
				if(scrollTop > this.width * 0.3 && this.n < 2) {
						this.n = 2
				}
				if(scrollTop > this.width * 0.8 && this.n < 3) {
						this.n = 3
				}
				if(scrollTop > this.width * 1.2 && this.n < 4) {
						this.n = 4
				}
				if(this.isMobile) {
					if(scrollTop > this.width * 1.4 + blockHeight && this.n < 8) {
							this.n = 8
					}
				}else {
					if(scrollTop > this.width * 1.4 + blockHeight && this.n < 5) {
							this.n = 5
					}
					if(scrollTop > this.width * 1.4 + blockHeight*2 && this.n < 6) {
							this.n = 6
					}
					if(scrollTop > this.width * 1.4 + blockHeight*3 && this.n < 7) {
							this.n = 7
					}
					if(scrollTop > this.width * 1.4 + blockHeight*4 && this.n < 8) {
							this.n = 8
					}
				}
				
		}
	},
	created() {
		this.isMobile = isMobile() || window.innerWidth < 600
	},
	mounted() {
        this.width = window.innerWidth > 1200 ? window.innerWidth : 1200;
				window.addEventListener('scroll', this.scroll, false)
				if(this.isMobile) {
					this.initSwiper()
					this.n = 1
				}
        setTimeout(() => {
			    this.n = 1
		    }, 500)
		this.initThree()
	},
	beforeDestroy() {
        window.removeEventListener('scroll', this.scroll, false)
    }
}
</script>
<style lang="scss">
@import '../assets/css/service.scss';
</style>
